import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Button } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalTagAllDelete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onDeleteAllTag, onToggleModal, tagAllCount } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-tagDelete-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalTagAllDelete_1', defaultMessage: '모든 태그 삭제' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTagAllDelete_3', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('gray-button')} disabled={isClicked} loading={isClicked} onClick={onDeleteAllTag}>
              {defineMessages(formatMessage({ id: 'ModalTagAllDelete_2', defaultMessage: '삭 제' }))}
            </Button>
          </div>
        }>
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ModalTagAllDelete_4',
              defaultMessage: '삭제한 태그는 복구할 수 없습니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ModalTagAllDelete_6',
              defaultMessage: '다음 태그를 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ModalTagAllDelete_5', defaultMessage: '태그 수' }))}
                </div>
                {tagAllCount + defineMessages(formatMessage({ id: 'TargetItem_7', defaultMessage: '개' }))}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}
ModalTagAllDelete.propTypes = {
  visible: PropTypes.bool,
  onToggleModal: PropTypes.func
};

export default injectIntl(ModalTagAllDelete);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalTagAllDelete.js